import ArrowDownIcon from '@atlaskit/icon/glyph/arrow-down';
import ArrowUpIcon from '@atlaskit/icon/glyph/arrow-up';
import Lozenge from '@atlaskit/lozenge';
import { Box } from '@atlaskit/primitives';

import { ChangedValueStyles, CurrentValue, LozengeDifference } from './styles';

type Props = {
  showCurrentValue: boolean;
  value: string;
  difference: string;
  hasDifference: boolean;
  isDifferenceImproved: boolean;
  isDifferenceIncreased: boolean;
};

const ValueDifference = ({
  showCurrentValue,
  difference,
  hasDifference,
  isDifferenceImproved,
  isDifferenceIncreased,
}: Omit<Props, 'value'>) => {
  if (!hasDifference) return null;

  return (
    <Lozenge
      isBold={!showCurrentValue}
      appearance={isDifferenceImproved ? 'success' : 'removed'}
    >
      {isDifferenceIncreased ? (
        <ArrowUpIcon size="small" label="" testId="changed-value-increased" />
      ) : (
        <ArrowDownIcon size="small" label="" testId="changed-value-decreased" />
      )}
      <LozengeDifference>{difference}</LozengeDifference>
    </Lozenge>
  );
};

export const ChangedValue = ({
  showCurrentValue,
  value,
  difference,
  hasDifference,
  isDifferenceImproved,
  isDifferenceIncreased,
}: Props) => {
  return (
    <Box xcss={ChangedValueStyles}>
      {!showCurrentValue ? null : (
        <CurrentValue isImproved={isDifferenceImproved}>{value}</CurrentValue>
      )}
      <ValueDifference
        showCurrentValue={showCurrentValue}
        difference={difference}
        hasDifference={hasDifference}
        isDifferenceIncreased={isDifferenceIncreased}
        isDifferenceImproved={isDifferenceImproved}
      />
    </Box>
  );
};
